<dialog
  #dialog
  qai-dialog
  [heading]="titleKey | transloco"
  [description]="descriptionKey | transloco"
  [showClose]="false"
>
  <div class="exit-buttons">
    <button qai-button size="medium" kind="destructive" (click)="onConfirmExit()">
      {{ 'learningPathway.EXIT_MODAL_EXIT' | transloco }}
    </button>
    <button qai-button size="medium" kind="primary" (click)="onResume()">
      {{ 'learningPathway.EXIT_MODAL_RESUME' | transloco }}
    </button>
  </div>
</dialog>
